/**
 * Injects variables into a string
 * @example: "test {0}".format(123) results in "test 123"
 * @returns {string}
 */
String.prototype.format = function () {
    const args = arguments;
    return this.replace(/\{\{|\}\}|\{(\d+)\}/g, function (m, n) {
        if (m === "{{") {
            return "{";
        }
        if (m === "}}") {
            return "}";
        }
        return args[n];
    });
};

/**
 * Extension method for strings allowing easy conversion to title-case.
 * @see: http://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
 */
String.prototype.toTitleCase = function () {
    return this.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

/**
 * Returns true if the strings ends with the test value
 * @param {String} test
 */
String.prototype.endsWith = function (test) {
    if (test == null) {
        return false;
    }
    return this.lastIndexOf(test) === this.length - test.length;
};

/**
 * Returns true if the strings starts with the test value
 * @param {String} test
 * @param {bool} [caseInsensitive]
 */
String.prototype.startsWith = function (test, caseInsensitive) {
    if (test == null) {
        return false;
    }

    if (caseInsensitive) {
        return this.toLowerCase().indexOf(test.toLowerCase()) === 0;
    }

    return this.indexOf(test) === 0;
};

/**
 * Concatenates Url fragments
 * @returns {string}
 */
String.prototype.concatUrl = function () {
    let parts = _.values(arguments);
    parts = _.map(parts, function (part) {
        if (part === "") {
            return "";
        }
        part = part + "";
        part = part.replace('\\', '/');
        return part.startsWith("/") ? part : "/" + part;
    });

    if (this.endsWith("/")) {
        parts.splice(0, 0, this.slice(0, this.length - 1));
    } else {
        parts.splice(0, 0, this);
    }

    return parts.join("");
};

/**
 * Gets the value of the flag at the specified position of an 8-bit bitmask.
 * @param position {number} The flag at the position. 1-based index, reading left-to-right.
 * @returns {boolean}
 */
String.prototype.getBitmaskFlag = function (position) {
    return this[8 - position] === '1';
};

/**
 * Pads a string with a number of characters
 * @param padCharacter {String}
 * @param count {number}
 * @returns {string}
 */
String.prototype.pad = function (padCharacter, count) {
    const padding = [];
    for (let i = 0; i < count - this.length; i++) {
        padding.push(padCharacter);
    }
    padding.push(this);
    return padding.join("");
};

/**
 * Appends a query string parameter to a URL
 * @param key
 * @param value
 * @returns {String|string}
 */
String.prototype.appendQuerystringParameter = function (key, value) {
    let url = this || '';

    key = escape(key);
    value = escape(value);

    if (url.indexOf('?') === -1) {
        const parts = [];
        parts.push(url);
        parts.push('?');
        parts.push(key);
        parts.push('=');
        parts.push(value);
        url = parts.join('');
    } else {
        const urlParts = url.split('?');
        const kvp = urlParts[1].split('&');

        let i = kvp.length;
        let x;
        while (i--) {
            x = kvp[i].split('=');

            if (x[0] === key) {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }

        if (i < 0) {
            kvp[kvp.length] = [key, value].join('=');
        }

        //this will reload the page, it's likely better to store this until finished
        url = urlParts[0] + '?' + kvp.join('&');
    }
    return url;
};

String.prototype.appendQuerystringParameters = function (param) {
    const url = this;
    if (!param) {
        return url.toString();
    }
    const obj = Object.entries(param)
        .reduce((a,[k,v]) => (v === undefined || v === null ? a : (a[k]=v, a)), {})
    if (obj == null) {
        return url.toString();
    }
    const qs = new URLSearchParams(obj);
    if (!qs.toString()) {
        return url.toString();
    }
    return (url.indexOf('?') === -1)
        ? url + '?' + qs.toString()
        : url + '&' + qs.toString();
};

/**
 * Format a string as a number to a certain precision
 * @param precision
 * @returns {number}
 */
String.prototype.formatNumber = function (precision) {
    const number = this;
    const multiplier = Math.pow(10, precision + 1),
        wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
};

/**
 * Adds methods to underscore to perform base 64 functions
 */
_.base64 = {
    // private property
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

// public method for encoding
    encode: function (input) {
        let output = "";
        let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        let i = 0;

        input = _.base64._utf8_encode(input);

        while (i < input.length) {

            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);

            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;

            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }

            output = output +
                _.base64._keyStr.charAt(enc1) + _.base64._keyStr.charAt(enc2) +
                _.base64._keyStr.charAt(enc3) + _.base64._keyStr.charAt(enc4);

        }

        return output;
    },

// public method for decoding
    decode: function (input) {
        let output = "";
        let chr1, chr2, chr3;
        let enc1, enc2, enc3, enc4;
        let i = 0;

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = _.base64._keyStr.indexOf(input.charAt(i++));
            enc2 = _.base64._keyStr.indexOf(input.charAt(i++));
            enc3 = _.base64._keyStr.indexOf(input.charAt(i++));
            enc4 = _.base64._keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 !== 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 !== 64) {
                output = output + String.fromCharCode(chr3);
            }

        }

        output = _.base64._utf8_decode(output);

        return output;

    },

// private method for UTF-8 encoding
    _utf8_encode: function (string) {
        string = string.replace(/\r\n/g, "\n");
        let utftext = "";

        for (let n = 0; n < string.length; n++) {

            const c = string.charCodeAt(n);

            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }

        return utftext;
    },

// private method for UTF-8 decoding
    _utf8_decode: function (utftext) {
        let string = "";
        let i = 0;
        let c = c1 = c2 = 0;

        while (i < utftext.length) {

            c = utftext.charCodeAt(i);

            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }

        }
        return string;
    }
};


/**
 * Checks if a string is null or whitespace
 * @param value {string}
 * @returns {boolean}
 */
_.isNullOrWhitespace = function (value) {

    if (value === null || value === undefined) {
        return true;
    }

    if (!_.isString(value)) {
        return true;
    }

    const result = value.match(/[^\s]+/gi);
    return result == null || result.length === 0;

};
